import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type { PageResponseDTO } from "@/shared/types/pagination.types";
import type { TagRequestDTO, TagResponseDTO, TagSearchParams } from "../types";

export const tagService = {
  search: async (
    params?: TagSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<TagResponseDTO>> => {
    const response = await api.get<PageResponseDTO<TagResponseDTO>>(
      API_ENDPOINTS.TAGS.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  getById: async (
    id: number,
    options?: RequestOptions,
  ): Promise<TagResponseDTO> => {
    const response = await api.get<TagResponseDTO>(
      API_ENDPOINTS.TAGS.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },

  create: async (data: TagRequestDTO): Promise<TagResponseDTO> => {
    const response = await api.post<TagResponseDTO>(
      API_ENDPOINTS.TAGS.BASE,
      data,
    );
    return response.data;
  },
};
